import React from 'react';
import Icon from '@xo-union/tk-component-icons';
import styles from './IconAgent.css'

export default class IconAgent extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const trackingData = this.props.trackingData || ''

    return (
      <span className={`${styles['icon-agent-size']} ${this.props.className}`} {...trackingData}>
        <Icon name={this.props.iconName} size={this.props.size}/>
      </span>
    );
  }
}
